import React from 'react'
import { Pill } from '../../../../../../shared/sso-workspace/pill'
import { IconSelectListReadonly } from '../../../../../../shared/icon/icon'
import { avatarColour, initialsOf } from '../../../../../../shared/recent-accounts/account-look'
import { formatDate } from '../../../../../../shared/sso-workspace/format'
import { isScim } from '../common/managed-by'
import { removedByText } from '../removal-words'
import { managedLine, statusOf } from './person-words'

// The person page's header (owner 2026-10-29: "a bare breadcrumb and no
// name"): who this is -- their name, their address exactly as stored (never
// title-cased), and one status line: "Active · Provisioned by EdXR Azure
// Dev", or "Removed · by Microsoft Entra ID (EdXR Azure Dev) · Oct 29, 2026".
// The page's actions sit on the right, the main one first.
export const PersonHeader = ({ person, removed, unknown, failed, actions, hasMain }) => {
  const loading = !person && !unknown && !failed
  const name = `${(person && person.firstName) || ''} ${(person && person.lastName) || ''}`.trim()
  const email = (person && person.email) || ''
  const title = name || email || (unknown ? 'Not a current member' : failed ? 'Person' : '')
  const status = statusOf({ removed, person })
  const managed = managedLine(person && person.managedBy)
  const by = removed ? removedByText(person) : ''
  const when = removed && person && person.removedAt ? formatDate(person.removedAt) : ''
  const showEmail = email && email !== title

  return (
    <header className={`sw-page-head pp-head${hasMain ? ' pp-has-main' : ''}`} data-testid="person-header">
      <div className="pp-who">
        {(name || email) &&
          <span className="pp-avatar" aria-hidden="true" style={{ '--pp-avatar': avatarColour(email || name) }}>
            {initialsOf({ name, email })}
          </span>}
        <div className="min-w-0">
          <h1 className="sw-title pp-name">{loading ? <span className="sw-hint">Loading…</span> : title}</h1>
          {showEmail && <div className="pp-email" data-testid="person-email">{email}</div>}
          {person && !unknown &&
            <div className="pp-status" data-testid="person-status">
              <Pill tone={status.tone}>{status.label}</Pill>
              {by && <span className="pp-status-part">by {by}</span>}
              {when && <span className="pp-status-part">{when}</span>}
              {managed &&
                <span className="pp-status-part" data-testid="managed-note">
                  {isScim(person.managedBy) && <IconSelectListReadonly className="me-1" />}
                  {managed}
                </span>}
            </div>}
        </div>
      </div>
      {actions && <div className="sw-page-actions pp-actions">{actions}</div>}
    </header>
  )
}
